'use client';

import Logo from "@/component/logo";
import { useLanguage } from "@/context/language-context";
import { getLocalizedPath } from "@/lib/routes";
import { cn } from "@/lib/utils";
import { Button } from "@heroui/react";
import { IconCheck, IconHome } from "@tabler/icons-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import Script from "next/script";
import { useEffect, useState } from "react";

export default function ContactReceivedClient() {
    const router = useRouter();
    const { language } = useLanguage();
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setTimeout(() => router.push('/'), 0);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [router]);

    return (
        <>
            <div
                className={cn(
                    "bg-[radial-gradient(hsl(var(--heroui-primary-800)_/_0.15)_10%,hsl(var(--heroui-primary)_/_0.0)_67%)]",
                    "dark:bg-[radial-gradient(hsl(var(--heroui-primary-800)_/_0.1)_10%,hsl(var(--heroui-primary)_/_0.0)_67%)]",
                    "min-h-screen flex items-center justify-center p-4"
                )}
                style={{
                    backgroundPosition: "0 -150px",
                    backgroundSize: "auto 1600px",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="max-w-md w-full text-center space-y-8">
                    <div className="flex justify-center mb-8">
                        <Logo />
                    </div>

                    <div className="bg-white/5 dark:bg-white/5 border border-white/10 rounded-lg p-8 backdrop-blur-sm">
                        <div className="flex justify-center mb-6">
                            <div className="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center">
                                <IconCheck size={32} className="text-success" />
                            </div>
                        </div>

                        <h1 className="text-2xl font-bold text-foreground mb-4">
                            {language === 'it' ? 'Richiesta Ricevuta!' : 'Request Received!'}
                        </h1>

                        <p className="text-default-600 mb-6">
                            {language === 'it'
                                ? 'Grazie per aver inviato la tua richiesta. Ti contatteremo presto per fornirti tutte le informazioni di cui hai bisogno.'
                                : 'Thank you for submitting your request. We will contact you soon to provide all the information you need.'
                            }
                        </p>

                        <div className="space-y-4">
                            <p className="text-sm text-default-500">
                                {language === 'it'
                                    ? `Sarai reindirizzato alla homepage in ${countdown} secondi`
                                    : `You will be redirected to the homepage in ${countdown} seconds`
                                }
                            </p>

                            <Button
                                as={Link}
                                href={getLocalizedPath('/', language)}
                                color="primary"
                                variant="flat"
                                startContent={<IconHome size={18} />}
                                className="w-full"
                            >
                                {language === 'it' ? 'Torna alla Homepage' : 'Go to Homepage'}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <Script id="linkedin-insight-partner" strategy="afterInteractive">
                {`
_linkedin_partner_id = "9115033";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);
                `}
            </Script>
            <Script id="linkedin-insight-loader" strategy="afterInteractive">
                {`
(function(l) {
if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
window.lintrk.q=[]}
var s = document.getElementsByTagName("script")[0];
var b = document.createElement("script");
b.type = "text/javascript";b.async = true;
b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})(window.lintrk);
                `}
            </Script>
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{ display: "none" }}
                    alt=""
                    src="https://px.ads.linkedin.com/collect/?pid=9115033&fmt=gif"
                />
            </noscript>
        </>
    );
}
